<template>
  <Loading class="loading" height="100%" />
</template>

<script>
import Loading from '@@/common/Loading';
import { RESET } from '@/store/types';
import { mapMutations } from 'vuex';

export default {
  name: 'Logout',
  components: { Loading },

  created() {
    this.logout();
  },

  methods: {
    ...mapMutations({ resetStore: RESET }),
    logout() {
      return this.$auth
        .logout()
        .then(() => {
          this.resetAndRedirect();
        })
        .catch(() => {
          const makeRequest = false;
          this.$auth.logout(makeRequest).then(() => {
            this.resetAndRedirect();
          });
        });
    },
    resetAndRedirect() {
      this.$router.replace({ name: 'login' });
      this.resetStore();
    },
  },
};
</script>

<style lang="scss">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
}
</style>
